<template>
  <div
    class="bottom-nav"
    :style="'background:' + config.property_data.background_color"
  >
    <div
      class="nav-item"
      v-for="(item, index) in config.link_data"
      :key="index"
    >
      <div>
        <div
          class="select-img-wrapper"
          :style="item.unselected_icon ? '' : 'background: #d8d8d8;'"
        >
          <img
            class="select-img"
            v-if="item.unselected_icon"
            :src="item.unselected_icon"
          />
        </div>
        <div
          class="text"
          :style="'color:' + config.property_data.unselected_font_color"
          v-if="config.property_data.is_font_show"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "tms-top-nav",
  props: ["config"],

  data() {
    return {
      property_data: {},
    };
  },

  components: {},

  mounted() {
    this.property_data = this.config.property_data;
  },

  methods: {},
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>